import React, { useState, useEffect, useMemo } from "react";
import "./MemoButtonComponent.css";
import { BiSend } from "react-icons/bi";
import { RiFileCopy2Line } from "react-icons/ri";
import { FaPrint } from "react-icons/fa";
import { Components } from "antd/lib/date-picker/generatePicker";
import { GeneratePDF } from "../../Services/ReviewPdfService";
import { Button } from "primereact/button";
import { useUserContext } from "../../Context/UserContext";
import { BsPencilSquare } from "react-icons/bs";
import { SetCheckAcces } from "../../Services/MemoService";
import useAlert from "../../hooks/useAlert";
import { useTranslation } from "react-i18next";
import { btoa } from "buffer";
import { useHistory, useLocation } from "react-router";
import { v4 as uuidv4 } from "uuid";
interface Props {
  memoIdForCopy: any;
  pdfData?: string;
  memoDetail?: any;
  isCheckAcces: boolean;
  canEdit: boolean;
  isControlLoading: boolean;
  setIsControlLoading: (value: boolean) => void;
  setCanEdit: (canEdit: boolean) => void;
  permission: any;
}
export const OtherButtonMemoComponent = (props: Props) => {
  const [userData, setUserData] = useUserContext();
  const [responeData, setResponeData] = useState<any>(props.pdfData);
  const [isCheckByOrigin, setIsCheckByOrigin] = useState<boolean>(false);
  const { t } = useTranslation(["translation"]);
  const { toggleAlert } = useAlert();
  const [uid, setUid] = useState<string | null>(null);
  let history = useHistory();
  var _localStorage = JSON.parse(localStorage.getItem("userData") || "");

  let _tinyURL = _localStorage.TinyURL;
  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const MemoID = query.get("MemoID")
  useEffect(() => {
      const generatedUid = uuidv4();
      setUid(generatedUid);
  }, []);

  useEffect(() => {    
    setData();
  }, []);

  var getUrl = window.location;
  var baseUrl = getUrl.protocol + "//" + getUrl.host;
  const buttonEdit = () => {
    let _listApprovalDetails = props.memoDetail.listApprovalDetails;
    const CheckEmp = _listApprovalDetails?.filter((e:any) => e.emp_id === userData.EmployeeId);
    
    if (CheckEmp.length !== 0) {
      if (IsCheckAccessEditing() || isCheckByOrigin) {
        return (
          <button
            className="memo-button copy"
            style={{
              height: "27px",
              paddingTop: "4px",
              display: "flex",
            }}
            onClick={() => {
              if (props.canEdit || isCheckByOrigin) {
                onSetCheckAccess(null);
              } else {
                props.setCanEdit(true);
              }
            }}
          >
            <BsPencilSquare />
            <p style={{ marginLeft: "2px" }}> Stop editing</p>
          </button>
        );
      } else {
        return (
          <button
            className="memo-button copy"
            style={{
              height: "27px",
              paddingTop: "4px",
              display: "flex",
            }}
            onClick={() => {
              if (props.canEdit) {
                props.setCanEdit(false);
              } else {
                onSetCheckAccess(userData.EmployeeId.toString());
              }
            }}
          >
            <BsPencilSquare />
            <p style={{ marginLeft: "2px" }}> isEditing</p>
          </button>
        );
      }
    }
  };
  const buttonCopy = () => {
    return (
      <button
        id="copyButton"
        className="memo-button copy"
        style={{
          height: "27px",
          paddingTop: "4px",
          display: "flex",
        }}
        onClick={() => {
          window.open(
            `${baseUrl}/Request?MemoID=${props.memoIdForCopy}&isCopy`,
            "_blank",
            "noreferrer"
          );
        }}
      >
        <RiFileCopy2Line />
        <p style={{ marginLeft: "2px" }}> {t("Copy")}</p>
      </button>
    );
  };

  const buttonPreviewPdf = () => {
    return (
      <button
        id="preview--pdf-Button"
        className="memo-button print"
        style={{
          height: "27px",
          paddingTop: "4px",
          display: "flex",
        }}
        onClick={() => {
              if (!responeData) return;

        const protocol = window.location.protocol;

        let tinyURL = _localStorage?.TinyURL;

        // fallback ถ้า TinyURL เป็น null/empty
        if (!tinyURL || tinyURL === "null") {
          tinyURL = window.location.host;
        }

        let pdfUrl = new URL(responeData, window.location.origin);
        let attachPath = pdfUrl.pathname; 
        // เช่น /TempAttachment/xxx.pdf

        let port = window.location.port;

        if (window.location.hostname === "localhost") {
          tinyURL = "localhost:5001";
        } else if (port && !tinyURL.includes(":")) {
          tinyURL = `${tinyURL}:${port}`;
        }

        const splitPath = attachPath.split("/").filter(Boolean);

          if (splitPath.length >= 2) {
          const rootPath = splitPath[0] || "";
          const docPath = splitPath[1] || "";

          const fullName = splitPath[splitPath.length - 1] || "";
          const lastIndex = fullName.lastIndexOf(".");

          const extension =
            lastIndex >= 0 ? fullName.substring(lastIndex + 1) : "";

          const name =
            lastIndex >= 0 ? fullName.substring(0, lastIndex) : fullName;

          window.open(
            `${protocol}//${tinyURL}/previewAttachment?WFID=${uid}&MemoID=${MemoID}&rootPath=${rootPath}&docPath=${docPath}&ext=${extension}&name=${encodeURIComponent(name)}`,
            "_blank",
            "noreferrer"
          );
        } else {
          console.error("Invalid attachPath", {
            responeData,
            attachPath,
            splitPath,
            tinyURL,
          });
        }
        }}
      >
        <RiFileCopy2Line />
        <p style={{ marginLeft: "2px" }}>{t("Preview Pdf")}</p>
      </button>
    );
  };
  const onOpenPdfLink = () => {
    const newUrl = new URL(responeData);
    newUrl.searchParams.set('WFID', uid as string);
    window.open(`${newUrl.href}`, "_blank", "noreferrer");
  };
  const buttonPrintPDF = () => {
    return (
      <button
        id="print-pdf-Button"
        className="memo-button print"
        style={{
          height: "27px",
          paddingTop: "4px",
          display: "flex",
        }}
        onClick={() => {
          onOpenPdfLink();
        }}
      >
        <FaPrint />

        <p style={{ marginLeft: "2px" }}>{t("Print")}</p>
      </button>
    );
  };

  const IsCheckAccessEditing = () => {
    let isCheck = false;
    if (
      props.memoDetail?.memoDetail?.actorCheckAccess?.EmployeeId ===
      userData.EmployeeId
    ) {
      isCheck = true;
    }
    return isCheck;
  };

  const onSetCheckAccess = async (RequesterId?: string | null) => {
    props.setIsControlLoading(true);
    const checkAccessRequestModel = {
      memoid: props.memoDetail.memoDetail.memoid.toString(),
      RequesterId: RequesterId,
    };
    console.log("memo=>checkAccessRequestModel", checkAccessRequestModel);
    const result = await SetCheckAcces(checkAccessRequestModel);
    console.log("memo=>result", result);
    if (result.result === "success") {
      if (RequesterId) {
        props.setCanEdit(true);
        setIsCheckByOrigin(true);
      } else {
        props.setCanEdit(false);
        setIsCheckByOrigin(false);
      }
    } else if (result.result === "NotAccess") {
      if (userData.Lang === "TH") {
        toggleAlert({
          description: `มีผู้อื่นกำลังแก้ไขเอกสารอยู่`,
          message: `Not Access.`,
          type: "error",
        });
      } else {
        toggleAlert({
          description: `You do not have edit memo.`,
          message: `Not Access.`,
          type: "error",
        });
      }
      props.setCanEdit(false);
    }
    props.setIsControlLoading(false);
  };

  async function setData() {
    let respone = await GeneratePDF(
      props.memoIdForCopy,
      userData,
      props.memoDetail
    );

    setResponeData(respone);
  }

  const checkIsAccessComponent = () => {
    if (userData.Lang === "TH") {
      return (
        <span>
          เอกสารฉบับนี้กำลังถูกแก้ไขอยู่โดย{" "}
          {props.memoDetail.memoDetail?.actorCheckAccess?.NameEn}
        </span>
      );
    } else {
      return (
        <span>
          This memo is editing by{" "}
          {props.memoDetail.memoDetail?.actorCheckAccess?.NameEn}
        </span>
      );
    }
  };

  return (
    <div className="memo-button-container">
      {props.memoDetail.memoDetail?.actorCheckAccess &&
      !IsCheckAccessEditing() ? (
        checkIsAccessComponent()
      ) : (
        <>
          {responeData ? (
            <>{buttonPreviewPdf()}</>
          ) : (
            <Button
              className="memo-button memo-loading dd ss set-preview-pdf"
              label={t("Preview Pdf") ?? ""}
              loading
            />
          )}
          {props.isCheckAcces && buttonEdit()}
          {props.permission === null || props.permission?.Copy === "T" ? (
            buttonCopy()
          ) : (
            <></>
          )}

          {responeData ? (
            <>
              {(props.permission?.Print === "T" || props.permission === null) &&
                buttonPrintPDF()}
            </>
          ) : (
            <Button
              className="memo-button memo-loading dd ss"
              label={t("Print") ?? ""}
              loading
            />
          )}
        </>
      )}
    </div>
  );
};
